



























import { GetSmsGodoPoint, Mall } from 'ncp-api-supporter';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

type MallPointItem = GetSmsGodoPoint & {
  mallName: string;
};

@Component
export default class SmsPointSummary extends Vue {
  @Prop({ required: true })
  private readonly selectMallNo!: '' | number;

  @State('malls', { namespace: 'mall' })
  private readonly malls!: Mall[];

  @State('smsPointList', { namespace: 'smsPoint' })
  private readonly smsPointList: GetSmsGodoPoint[];
  @Action('fetchPoints', { namespace: 'smsPoint' })
  private readonly fetchPoints: Function;

  private mallPointList: MallPointItem[] | null = null;

  async created() {
    if (!this.smsPointList.length) {
      await this.fetchPoints();
    }

    this.mapPoint();
  }

  private mapPoint(): void {
    if (this.smsPointList.length <= 0) {
      return;
    }

    this.mallPointList = this.malls.map(({ mallName, mallNo }) => {
      const pointData = this.smsPointList.find((item) => item.mallNo === mallNo);

      return {
        mallName,
        mallNo,
        point: 0,
        ...pointData,
      };
    });
  }

  get totalPoint() {
    const total = this.selectMallNo ? this.getSelectedMallPoint() : this.sumPoints();
    if (typeof total !== 'number') {
      return '-';
    }

    return total > 0 ? total.toFixed(1) : 0;
  }

  private sumPoints(): number | undefined {
    return this.mallPointList?.reduce((acc, { point }) => acc + point, 0);
  }

  private getSelectedMallPoint(): number | undefined {
    const selectedMall = this.mallPointList?.find(({ mallNo }) => mallNo === this.selectMallNo);

    return selectedMall?.point;
  }
}
